import {
  createComponentMapperModel,
  withCompInfo,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import type {
  IResponsivePopupContainerProps,
  IResponsivePopupContainerStateRefsValues,
} from '../ResponsivePopupContainer.types';

export const props = withCompInfo<
  IResponsivePopupContainerProps,
  any, // There is no ResponsivePopupContainerDefinition in TB Components
  IResponsivePopupContainerProps
>()([], (_, carmiData) => carmiData);

export const uiType = withCompInfo<any, any>()(['skin'], ({ skin }) => {
  if (skin === 'WithOverlay') {
    return 'WithOverlay';
  }
  return undefined;
});

export const stateRefs = withStateRefsValues<
  keyof IResponsivePopupContainerStateRefsValues
>(['setSiteScrollingBlocked']);

export default createComponentMapperModel({ props, stateRefs, uiType });
